import { roundCredits } from "./common";
import { getTestStatus, getToolkitStatusAsYii, moderatedTestAddExtraFields } from "./test_functions";
import {
  YESNO,
  PURPOSE,
  PRODUCTS,
  USER_ROLES,
  TEST_STATUS,
  INVITE_TYPE,
  PLAN_FEE_TYPE,
  TEST_TYPE_TASK,
  TEST_TYPE_SURVEY,
  TEST_TYPE_TREETEST,
  TEST_TYPE_CARDSORT,
  TEST_TYPE_MODERATED,
  TEST_TYPE_NORECORDING,
  ORGANIZATION_TEAM_SIZE,
} from "../actions/constants";

const { SMALL_1, SMALL_2_10, MEDIUM_11_50, MEDIUM_51_100, LARGE_100_PLUS } = ORGANIZATION_TEAM_SIZE;

// Products
export const getProducts = () => {
  return [
    {
      key: "moderatedt",
      title: "Usability test",
      icon: "unmoderated",
      className: "bg-EAEFFD",
      description: "Test how usable your prototype or live product is",
      tutorials: [
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
      ],
      tryOutLinks: {
        title: "Try it out",
        links: [
          { title: "Introduction to test creation", url: "https://www.uxarmy.com" },
          { title: "Tester experience", url: "https://www.uxarmy.com" },
          { title: "Sample report", url: "https://www.uxarmy.com" },
        ],
      },
      moreLinks: {
        title: "Learn more",
        links: [
          { title: "Help and support", url: "https://www.uxarmy.com" },
          { title: "Case studies", url: "https://www.uxarmy.com" },
          { title: "Frequently asked questions", url: "https://www.uxarmy.com" },
        ],
      },
    },
    {
      key: "deepdive",
      title: "DeepDive",
      icon: "moderated",
      className: "bg-EEFBF4",
      description: "In-depth deep diving with your users",
      tutorials: [
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
      ],
      tryOutLinks: {
        title: "Try it out",
        links: [
          { title: "Introduction to test creation", url: "https://www.uxarmy.com" },
          { title: "Tester experience", url: "https://www.uxarmy.com" },
          { title: "Sample report", url: "https://www.uxarmy.com" },
        ],
      },
      moreLinks: {
        title: "Learn more",
        links: [
          { title: "Help and support", url: "https://www.uxarmy.com" },
          { title: "Case studies", url: "https://www.uxarmy.com" },
          { title: "Frequently asked questions", url: "https://www.uxarmy.com" },
        ],
      },
    },
    {
      key: "cardsort",
      title: "Card Sorting",
      icon: "card_sorting",
      className: "bg-FEF0F4",
      description: "Discover user's mental modal with information",
      tutorials: [
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
      ],
      tryOutLinks: {
        title: "Try it out",
        links: [
          { title: "Introduction to test creation", url: "https://www.uxarmy.com" },
          { title: "Tester experience", url: "https://www.uxarmy.com" },
          { title: "Sample report", url: "https://www.uxarmy.com" },
        ],
      },
      moreLinks: {
        title: "Learn more",
        links: [
          { title: "Help and support", url: "https://www.uxarmy.com" },
          { title: "Case studies", url: "https://www.uxarmy.com" },
          { title: "Frequently asked questions", url: "https://www.uxarmy.com" },
        ],
      },
    },
    {
      key: "treetest",
      title: "Tree Testing",
      icon: "tree_testing",
      className: "bg-F4F1FD",
      description: "Evaluate information architecture",
      tutorials: [
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
      ],
      tryOutLinks: {
        title: "Try it out",
        links: [
          { title: "Introduction to test creation", url: "https://www.uxarmy.com" },
          { title: "Tester experience", url: "https://www.uxarmy.com" },
          { title: "Sample report", url: "https://www.uxarmy.com" },
        ],
      },
      moreLinks: {
        title: "Learn more",
        links: [
          { title: "Help and support", url: "https://www.uxarmy.com" },
          { title: "Case studies", url: "https://www.uxarmy.com" },
          { title: "Frequently asked questions", url: "https://www.uxarmy.com" },
        ],
      },
    },
    {
      key: "surveys",
      title: "Survey",
      icon: "surveys",
      className: "bg-FFF9EB",
      description: "Get quick handy feedback",
      tutorials: [
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
        {
          url: "https://www.uxarmy.com",
          title: "Creating an Unmoderated Usability Test in UXArmy",
          thumbnail: "https://www.sandsresorts.com/wp-content/uploads/2014/08/placeholder-image-resort-thumbnail.jpg",
        },
      ],
      tryOutLinks: {
        title: "Try it out",
        links: [
          { title: "Introduction to test creation", url: "https://www.uxarmy.com" },
          { title: "Tester experience", url: "https://www.uxarmy.com" },
          { title: "Sample report", url: "https://www.uxarmy.com" },
        ],
      },
      moreLinks: {
        title: "Learn more",
        links: [
          { title: "Help and support", url: "https://www.uxarmy.com" },
          { title: "Case studies", url: "https://www.uxarmy.com" },
          { title: "Frequently asked questions", url: "https://www.uxarmy.com" },
        ],
      },
    },
  ];
};

// Add Extra Params for Common Dashboard Tests
export const addExtraParamsToTest = (testObj) => {
  const { id, draft_id = testObj?.id } = testObj;
  const extraParamsInfo = {
    0: {
      icon: "tutorial_treetest",
      bgColor: "bg-8D6CEF",
      textColor: "text-white",
      product: PRODUCTS.TREETESTING,
      testLinks: {
        edit: `/tests/${id}`,
        report: `/tests/report/${id}`,
        preview: `/study/${id}/preview`,
      },
      totalResponses: testObj?.responses?.completed || 0,
      totalRequiredResponses: testObj?.settings?.max_completed || 0,
    },
    2: {
      icon: "tutorial_cardsort",
      bgColor: "bg-F87CE4",
      textColor: "text-white",
      product: PRODUCTS.CARDSORTING,
      testLinks: {
        edit: `/tests/${id}`,
        report: `/tests/report/${id}`,
        preview: `/study/${id}/preview`,
      },
      totalResponses: testObj?.responses?.completed || 0,
      totalRequiredResponses: testObj?.settings?.max_completed || 0,
    },
    survey: {
      icon: "tutorial_surveys",
      bgColor: "bg-FFCE5C",
      textColor: "color-523900",
      product: PRODUCTS.SURVEYS,
      testLinks: {
        edit: `/test/${draft_id}`,
        report: `/test/${draft_id}/report`,
        preview: `/preview/${id}`,
      },
      totalResponses: Number(testObj?.tester_count) || 0,
      totalRequiredResponses:
        (Number(testObj?.use_visitors) === YESNO.YES ? Number(testObj?.visitors_max) : 0) +
        (Number(testObj?.use_uxarmy_testers) === YESNO.YES ? Number(testObj?.users_max) : 0),
    },
    moderated: {
      icon: "tutorial_deepdive",
      bgColor: "bg-EAEFFD",
      textColor: "text-white",
      product: PRODUCTS.MODERATED,
      testLinks: {
        edit: `/moderated/${id}/edit`,
        report: `/moderated/${id}/report`,
        preview: null,
      },
      totalResponses: Number(testObj?.total_completed_sessions) || 0,
      totalRequiredResponses: Number(testObj?.total_sessions) || 0,
    },
    task: {
      icon: "tutorial_moderated",
      bgColor: "bg-7B9CF1",
      textColor: "text-white",
      product: PRODUCTS.UNMODERATED,
      testLinks: {
        edit: `/test/${draft_id}`,
        report: `/test/${draft_id}/report`,
        preview: `/preview/${id}`,
      },
      totalResponses: Number(testObj?.tester_count) || 0,
      totalRequiredResponses:
        (Number(testObj?.use_visitors) === YESNO.YES ? Number(testObj?.visitors_max) : 0) +
        (Number(testObj?.use_uxarmy_testers) === YESNO.YES ? Number(testObj?.users_max) : 0),
    },
  };

  const extraParams = extraParamsInfo[testObj?.type] || {};
  const status = Number(testObj?.status) || TEST_STATUS.DRAFT;
  const isDeepDive = extraParams?.product === PRODUCTS.MODERATED || false;
  const test = isDeepDive ? moderatedTestAddExtraFields(testObj) : testObj;
  const isRecordingOff = parseInt(testObj?.is_recording_off) === YESNO.YES;
  const isDraft = [TEST_STATUS.DRAFT, TEST_STATUS.SAVED_TEST].includes(status);

  return {
    ...test,
    status,
    isDraft,
    isDeepDive,
    ...extraParams,
    isRecordingOff,
    name: test?.name || "Untitled Test",
    isCompleted: status === TEST_STATUS.COMPLETED,
    isSurveyTest: testObj?.type === TEST_TYPE_SURVEY,
    isToolkitTest: [0, 2].includes(Number(test?.type)),
    creator: test?.user ? `${test?.user?.first_name} ${test?.user?.last_name}` : "",
    actionLink: isDraft ? extraParams?.testLinks?.edit : extraParams?.testLinks?.report,
  };
};

// Organization Team Size
export const getOrganizationTeamSizeLabels = () => {
  return [
    { key: SMALL_1, value: SMALL_1, label: "1" },
    { key: SMALL_2_10, value: SMALL_2_10, label: "2 - 10" },
    { key: MEDIUM_11_50, value: MEDIUM_11_50, label: "11 - 50" },
    { key: MEDIUM_51_100, value: MEDIUM_51_100, label: "51 - 100" },
    { key: LARGE_100_PLUS, value: LARGE_100_PLUS, label: "100 & above" },
  ];
};

// Get Organization Team Size
export const getOrganizationTeamSize = (k = SMALL_1) => getOrganizationTeamSizeLabels().find(({ key }) => key === Number(k));

// Get Test Type Icon
export const getTestTypeIcon = (testType) => {
  const testTypeIcons = {
    [TEST_TYPE_TREETEST]: "tutorial_treetest",
    [TEST_TYPE_NORECORDING]: "tutorial_moderated",
    [TEST_TYPE_CARDSORT]: "tutorial_cardsort",
    [TEST_TYPE_SURVEY]: "tutorial_surveys",
    [TEST_TYPE_MODERATED]: "tutorial_deepdive",
    [TEST_TYPE_TASK]: "tutorial_moderated",
  };

  return testTypeIcons[testType];
};

export const getTestTypeDescription = (testType) => {
  const testTypeDescriptions = {
    [TEST_TYPE_TREETEST]: "Tree test study",
    [TEST_TYPE_NORECORDING]: "Figma no-recording study",
    [TEST_TYPE_CARDSORT]: "Card sort study",
    [TEST_TYPE_SURVEY]: "Survey",
    [TEST_TYPE_MODERATED]: "Moderated research study",
    [TEST_TYPE_TASK]: "Usability study",
  };

  return testTypeDescriptions[testType];
};

export const getRecentTestUrl = (id, testType) => {
  const isModerated = testType === TEST_TYPE_MODERATED;
  const isToolkit = testType === TEST_TYPE_CARDSORT || testType === TEST_TYPE_TREETEST;

  if (isToolkit) return `/tests/${id}`;
  if (isModerated) return `/moderated/${id}/report`;

  return `/test/${id}`;
};

export const getRecentTestStatus = (testType, status) => {
  const isToolkit = testType === TEST_TYPE_CARDSORT || testType === TEST_TYPE_TREETEST;

  return isToolkit ? getTestStatus(getToolkitStatusAsYii(Number(status))) : getTestStatus(Number(status));
};

// Get Simplified Plans
export const getSimplifiedPlans = (plans = []) => {
  return plans.map(({ name, fee_type, month, year, ...p }) => {
    const {
      amount,
      product_id,
      description,
      plan_features,
      pricing_order,
      plan_configurations,
      discount_percent = 0,
    } = fee_type === PLAN_FEE_TYPE.MANUAL ? year : month;

    const isPaid = fee_type === PLAN_FEE_TYPE.PAID;

    // Yearly amount after discount
    if (year) {
      year.amountTotal = month?.amount * 12;
      year.discountAmount = year?.discount_percent > 0 ? year?.amountTotal * (year?.discount_percent / 100) : 0;
    }

    // Monthly amount after discount
    if (month) {
      month.discountAmount = month?.discount_percent > 0 ? month?.amount * (month?.discount_percent / 100) : 0;
    }

    return {
      ...p,
      name,
      year,
      month,
      isPaid,
      fee_type,
      product_id,
      description,
      plan_features,
      pricing_order,
      monthlyAmount: roundCredits(amount, 2),
      isFree: fee_type === PLAN_FEE_TYPE.FREE,
      isCustom: fee_type === PLAN_FEE_TYPE.MANUAL,
      discount_percent: roundCredits(discount_percent, 2),
      yearlyAmount: year ? Math.round(year?.amount / 12, 2) : 0,
      isProPlan: (isPaid && plan_configurations?.teamManagement?.enabled) || false,
    };
  });
};

// Get Credit History Description
export const getCreditHistoryDescription = (hisObj) => {
  if (hisObj) {
    const { test = null, purpose = null, test_type = "", transaction_type = "debit" } = hisObj;
    const purposeAsNumber = Number(purpose);
    const isDedit = transaction_type === "debit";
    const isCredit = transaction_type === "credit";

    // Old Credit History - no purpose
    if (purpose === null || purpose === undefined || purposeAsNumber === PURPOSE.TEST_PARTICIPATION) {
      return isDedit
        ? !test_type
          ? "Credit Deducted"
          : test?.name || "Deleted Test"
        : isCredit
        ? "Credit Topup"
        : "Platform credit monthly reset";
    }

    // Admin Purpose
    if (purposeAsNumber === PURPOSE.ADMIN) return isCredit ? "Credit Added" : "Credit Deducted";

    // Purpose Descriptions
    const purposeDescs = {
      [PURPOSE.BONUS]: "Bonus Credit",
      [PURPOSE.TOPUP]: "Credit Topup",
      [PURPOSE.REFUND]: "Credit Refunded",
      [PURPOSE.SUBSCRIPTION_RENEWAL]: "Credit Reset",
      [PURPOSE.FREE_PLAN_ACTIVATED]: "Free Plan Credits",
      [PURPOSE.SUBSCRIPTION_START]: "Subscription Activated",
      [PURPOSE.SUBSCRIPTION_UPGRADE]: "Subscription Upgraded",
    };

    // with purpose
    if (purposeDescs[purposeAsNumber]) return purposeDescs[purposeAsNumber];
  }

  return "";
};

// Get User Role Options
export const getUserRoleOptions = () => {
  return [
    {
      label: "Admin",
      labelInSmall: "admin",
      labelAsText: "an admin",
      value: USER_ROLES.ADMIN,
      description: "Can change settings, but can't delete the workspace.",
    },
    {
      label: "Editor",
      labelInSmall: "editor",
      labelAsText: "an editor",
      value: USER_ROLES.WRITE,
      description: "Can create, edit, delete test, but can't change the workspace settings.",
    },
    {
      isFree: true,
      label: "Collaborator",
      labelInSmall: "collaborator",
      labelAsText: "a collaborator",
      value: USER_ROLES.COLLABORATOR,
      description: "Can access test reports & analysis to create video clips, annotations and highlight reels.",
    },
  ];
};

// Get User Role
export const getUserRole = (role) => getUserRoleOptions()?.find(({ value }) => value === role);

// Get Billing Admin Options
export const getBillingAdminOptions = () => {
  return [
    {
      label: "Organization Admin",
      value: INVITE_TYPE.ORGANIZATION,
      description: "Manage organization-wide settings, domains, billing, and user access across all workspaces.",
    },
    {
      label: "Workspace Admin",
      value: INVITE_TYPE.WORKSPACE,
      description: "Control workspace settings, members, and team assignments within specific workspaces.",
    },
    // {
    //   isFree: true,
    //   label: "Billing Admin",
    //   value: INVITE_TYPE.BILLING,
    //   description: "Handle payments, subscriptions, and seat management for assigned billing groups.",
    // },
  ];
};

// Get User Access Object
export const getUserAccessObject = (access = {}) => {
  const { role = USER_ROLES.COLLABORATOR, resourceType = INVITE_TYPE.WORKSPACE } = access || {};

  // Role
  const isOwner = role === USER_ROLES.OWNER;
  const isAdmin = role === USER_ROLES.ADMIN;

  // Resource Type
  const isWorkspace = resourceType === INVITE_TYPE.WORKSPACE;
  const isOrganization = resourceType === INVITE_TYPE.ORGANIZATION;

  // Allow Payments by Admin or Owner of Organization
  const isOrgAdminOrOwner = (isOwner || isAdmin) && isOrganization;

  return {
    role,
    isOwner,
    isAdmin,
    isWorkspace,
    resourceType,
    isOrganization,
    isOrgAdminOrOwner,
    isAdminOrOwner: isAdmin || isOwner,
    isWorkspaceOwner: isOwner && isWorkspace,
    isWorkspaceAdmin: isAdmin && isWorkspace,
    isOrganizationOwner: isOwner && isOrganization,
    isOrganizationAdmin: isAdmin && isOrganization,
    isViewer: role === USER_ROLES.READ && isWorkspace,
    isEditor: role === USER_ROLES.WRITE && isWorkspace,
    isCollaborator: role === USER_ROLES.COLLABORATOR && isWorkspace,
  };
};

// Get User Access Role
export const getUserAccessRole = (access = null) => {
  if (access) {
    const userAccess = getUserAccessObject(access);

    if (userAccess?.isOwner) return "Owner";
    if (userAccess?.isEditor) return "Editor";
    if (userAccess?.isCollaborator) return "Collaborator";
    if (userAccess?.isWorkspaceAdmin) return "Workspace Admin";
    if (userAccess?.isOrganizationAdmin) return "Organization Admin";
    if (userAccess?.isViewer) return "Viewer";
  }

  return "N/A";
};
